import { useEffect, useState } from "react";
import { Card, Title, Button, Divider, TextInput } from "@tremor/react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Alert from "../../components/alert";
import { useAuth } from "../../services/AuthProvider";
import { Crisp } from "crisp-sdk-web";
import * as userAPI from "../../services/user";
import ThemeToggle from "../../components/ThemeToggle";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login, isAuthenticated, currentUser } = useAuth();
  const [searchParams] = useSearchParams();
  const [isRegOk, setIsRegOk] = useState(searchParams.get("regok"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated()) {
      Crisp.user.setEmail(currentUser.email);
      navigate("/devices");
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const data = await userAPI.login(username, password);
      setLoading(false);
      login(data.user, data.token);
      navigate("/devices");
    } catch (err) {
      setLoading(false);
      setIsRegOk("false");
      setError(err.error || "Failed to login");
      setTimeout(() => {
        setError(null);
      }, 3000);
    }
  };

  return (
    <main className="p-4 md:p-10 mx-auto max-w-7xl">
      <ThemeToggle compact className="fixed right-4 top-4" />
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <a href="/" className="flex items-center mb-6 text-2xl font-semibold">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2">
            <rect x="0" y="0" width="40" height="40" rx="9" ry="9" fill="#2563eb"/>
            <text x="20" y="28" textAnchor="middle" fontFamily="Arial, Helvetica, sans-serif" fontWeight="300" fontSize="22" fill="#ffffff">Z</text>
          </svg>
          Zafron
        </a>
        <Card className="max-w-xs">
          <Title>Login</Title>
          <Divider />
          {isRegOk === "true" && (
            <Alert
              title="Registration Success"
              type="success"
              message={"You have successfully registered. Please login."}
            />
          )}
          {error && (
            <Alert
              title="Login Error"
              message={"Email or password is invalid."}
            >
              {error}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2"
                htmlFor="username"
              >
                E-mail
              </label>
              <TextInput
                type="email"
                placeholder="E-mail address"
                value={username}
                onChange={(e) => setUsername(e.target.value)} // Update the username state when the input changes
              />
            </div>
            <div className="mb-4">
              <label
                className="block text-gray-700 dark:text-gray-300 text-sm font-bold mb-2"
                htmlFor="password"
              >
                Password:
              </label>
              <TextInput
                id="password"
                type="password"
                placeholder=""
                value={password}
                onChange={(e) => setPassword(e.target.value)} // Update the password state when the input changes
              />
            </div>
            <div className="mb-4 ">
              <Button
                type="submit"
                variant="primary"
                size="xs"
                loading={loading}
                className="w-full"
              >
                Login
              </Button>
              <p className="mt-2 text-gray-400 dark:text-gray-500 text-sm">
                Forgot Password?{" "}
                <Link
                  className="text-blue-600 dark:text-blue-500 hover:underline"
                  to="/forgot-password"
                >
                  {" "}
                  Reset Password
                </Link>
              </p>
            </div>
          </form>
          <div className="mb-4">
            <Divider>or</Divider>
            <Button
              variant="secondary"
              size="xs"
              className="w-full"
              onClick={() => navigate("/register")}
            >
              Sign Up
            </Button>
          </div>
        </Card>
      </div>
    </main>
  );
}
